// extracted by mini-css-extract-plugin
export default {"root":"tplWgI5kbIBNN516zeuG","flag":"AQyCr1dOY80TLINB_vvS"};